import { gql } from '@apollo/client';

export const GQL_UPLOAD_CREDIT_CARD_ACTIVATION_DOCUMENT = gql`
  mutation uploadCreditCardActivationDocument($file: Upload!) {
    uploadCreditCardActivationDocument(file: $file) {
      fileName
      fileId
      errorMessage
    }
  }
`;

export const GQL_REQUEST_CREDIT_CARD_ACTIVATION_ACCESS = gql`
  mutation requestCreditCardActivationAccess {
    requestCreditCardActivationAccess {
      status
      message
      errorMessage
    }
  }
`;

export const GQL_SUBMIT_CREDIT_CARD_ACTIVATION = gql`
  mutation submitCreditCardActivation($input: CreditCardActivationInput!) {
    submitCreditCardActivation(input: $input) {
      status
      message
      verificationId
      businessId
      errorMessage
    }
  }
`;
